import React, { useState, useEffect } from "react";
import "../../Styles/Pages/Admin/Farmers.css";
import Admin_topbar from "../../Layouts/Admin_layout/Admin_topbar";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
  Pagination,
  Typography,
  Modal,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import "../../Styles/Pages/admin_fieldofficers.css";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { NavLink } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomDatePicker from "../../Components/Admin/CustomDatePicker";
import dayjs from "dayjs";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": { backgroundColor: alpha(theme.palette.common.white, 0.25) },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: { marginLeft: theme.spacing(1), width: "auto" },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: { width: "12ch", "&:focus": { width: "20ch" } },
  },
}));

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: "2px",
};

function Farmers() {
  const [farmers, setFarmers] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [farmerpage] = useState(10);
  const [isAdmin, setIsAdmin] = useState(false);

  // Three dots menu
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFarmer, setMenuFarmer] = useState(null);

  // Delete modal
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteFarmerData, setDeleteFarmerData] = useState(null);
  const [deleteFieldCount, setDeleteFieldCount] = useState(0);

  // Permission modal
  const [permModalOpen, setPermModalOpen] = useState(false);
  const [permFarmer, setPermFarmer] = useState(null);
  const [permEditEnabled, setPermEditEnabled] = useState(false);
  const [permStartDate, setPermStartDate] = useState('');
  const [permEndDate, setPermEndDate] = useState('');

  const indexOfLastfarmer = currentPage * farmerpage;
  const indexOfFirstfarmer = indexOfLastfarmer - farmerpage;
  const currentfarmer = filteredFarmers.slice(indexOfFirstfarmer, indexOfLastfarmer);

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase().trim();
    setSearch(query);
    if (!query) {
      setFilteredFarmers(farmers);
    } else {
      const filtered = farmers.filter((farmer) =>
        Object.values(farmer).some((value) =>
          value !== null && value !== undefined && value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredFarmers(filtered);
    }
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchFarmers = async () => {
    try {
      const response = await instance.get("/getFarmers");
      const sorted = response.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setFarmers(sorted);
      setFilteredFarmers(sorted);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFarmers();
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded.role === "Admin" || decoded.role === "Vendor") setIsAdmin(true);
    }
  }, []);

  // Three dots menu handlers
  const handleMenuOpen = (event, farmer) => {
    setAnchorEl(event.currentTarget);
    setMenuFarmer(farmer);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuFarmer(null);
  };

  // Delete flow
  const handleDeleteClick = async () => {
    handleMenuClose();
    if (!menuFarmer) return;
    try {
      const response = await instance.get(`/getFarmerFieldCount?farmer_id=${menuFarmer._id}`);
      setDeleteFarmerData(menuFarmer);
      setDeleteFieldCount(response.data.fieldCount || 0);
      setDeleteModalOpen(true);
    } catch (err) {
      toast.error("Error fetching farmer details");
    }
  };

  const handleConfirmDelete = async () => {
    if (!deleteFarmerData) return;
    try {
      const response = await instance.delete(`/deleteFarmer?farmer_id=${deleteFarmerData._id}`);
      if (response.data.success) {
        toast.success("Farmer deleted successfully");
        fetchFarmers();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error deleting farmer");
    } finally {
      setDeleteModalOpen(false);
      setDeleteFarmerData(null);
    }
  };

  // Permission flow
  const handleEditPermissionClick = () => {
    handleMenuClose();
    if (!menuFarmer) return;
    setPermFarmer(menuFarmer);
    setPermEditEnabled(menuFarmer.edit_permission || false);
    setPermStartDate(menuFarmer.edit_start_date ? menuFarmer.edit_start_date.split('T')[0] : '');
    setPermEndDate(menuFarmer.edit_end_date ? menuFarmer.edit_end_date.split('T')[0] : '');
    setPermModalOpen(true);
  };

  const handleSavePermission = async () => {
    try {
      const response = await instance.post('/setFarmerEditPermission', {
        farmer_id: permFarmer._id,
        edit_permission: permEditEnabled,
        edit_start_date: permStartDate || null,
        edit_end_date: permEndDate || null,
      });
      if (response.data.success) {
        toast.success(`Permission updated for ${permFarmer.name}`);
        setPermModalOpen(false);
        fetchFarmers();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error updating permission");
    }
  };

  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Admin_topbar />
      <div className="officer_section">
        <section className="main_box">
          <div className="container-fluid">
            <div className="table_box">
              <TableContainer component={Paper}>
                <div className="table_inbox">
                  <div className="add_user_list">
                    <div className="add_user_content">
                      <div style={{ fontFamily: "Poppins,sans-serif", fontSize: "20px", fontWeight: "bold" }}>
                        Farmers
                      </div>
                    </div>
                    <div className="add_user">
                      <div>
                        <Search>
                          <SearchIconWrapper><SearchIcon /></SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            type="search"
                            value={search}
                            onChange={handleSearch}
                          />
                        </Search>
                      </div>
                    </div>
                  </div>
                  <div className="adduser_table">
                    <Table className="user_table product_table" aria-label="simple table">
                      <TableHead>
                        <TableRow className="table_head">
                          <TableCell align="center" className="first-child">Sl.No</TableCell>
                          <TableCell align="center" className="second-child">Farmer Name</TableCell>
                          <TableCell align="center" className="third-child">Mobile</TableCell>
                          <TableCell align="center" className="third-child">Aadhaar Number</TableCell>
                          <TableCell align="center" className="third-child">Village</TableCell>
                          <TableCell align="center" className="third-child">District</TableCell>
                          <TableCell align="center" className="third-child">State</TableCell>
                          <TableCell align="center" className="third-child">Category</TableCell>
                          <TableCell align="center" className="second-child">Vendor Name</TableCell>
                          <TableCell align="center">View</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="table_body">
                        {currentfarmer.length > 0 ? (
                          currentfarmer.map((farmer, index) => (
                            <TableRow key={farmer._id}>
                              <TableCell align="center">{index + 1 + (currentPage - 1) * farmerpage}</TableCell>
                              <TableCell align="center">{farmer.name}</TableCell>
                              <TableCell align="center">{farmer.mobile_no}</TableCell>
                              <TableCell align="center">{farmer?.aadhaar_number}</TableCell>
                              <TableCell align="center">{farmer?.village}</TableCell>
                              <TableCell align="center">{farmer?.district}</TableCell>
                              <TableCell align="center">{farmer?.state}</TableCell>
                              <TableCell align="center">{farmer?.category}</TableCell>
                              <TableCell align="center">{farmer?.vendor?.name}</TableCell>
                              <TableCell align="center">
                                <NavLink to={`/admin/Fields/${farmer.hash}`} className="farmer-details">
                                  <FiEye />
                                </NavLink>
                              </TableCell>
                              <TableCell align="center">
                                <MoreVertIcon
                                  onClick={(e) => handleMenuOpen(e, farmer)}
                                  style={{ cursor: 'pointer', color: '#555' }}
                                />
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={11} align="center">
                              <Typography>No matched items</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                  <div className="pagination_table">
                    <Pagination
                      count={Math.ceil(filteredFarmers.length / farmerpage)}
                      page={currentPage}
                      onChange={(event, page) => paginate(page)}
                      shape="rounded"
                      variant="outlined"
                    />
                  </div>
                </div>
              </TableContainer>
            </div>
          </div>
        </section>
      </div>

      {/* Three dots dropdown menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {isAdmin && (
          <MenuItem onClick={handleEditPermissionClick}>
            Edit Permission
          </MenuItem>
        )}
        <MenuItem onClick={handleDeleteClick} sx={{ color: '#f44336' }}>
          Delete
        </MenuItem>
      </Menu>

      {/* Delete Confirmation Modal (same pattern as FieldOfficers) */}
      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <Box sx={modalStyle}>
          <div id="delete-modal-title" style={{ fontWeight: 'bold', fontSize: '16px', color: '#f44336' }}>
            ⚠️ Caution - Delete Farmer
          </div>
          <div style={{ margin: '12px 0', fontFamily: 'Poppins,sans-serif', fontSize: '14px' }}>
            Are you sure you want to delete <b>{deleteFarmerData?.name}</b>?
          </div>
          {deleteFieldCount > 0 && (
            <div style={{ color: '#f44336', fontWeight: 'bold', margin: '8px 0', fontSize: '13px', background: '#fff3f3', padding: '8px 12px', borderRadius: 4 }}>
              ⚠️ This farmer has <b>{deleteFieldCount}</b> field{deleteFieldCount > 1 ? 's' : ''} associated. All fields will also be permanently deleted.
            </div>
          )}
          <div id="delete-modal-description">
            <Button variant="contained" className="yes" onClick={handleConfirmDelete}>
              Yes, Delete
            </Button>
            <Button variant="contained" className="no" onClick={() => setDeleteModalOpen(false)}>
              No, Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Permission Modal (same pattern as FieldOfficers) */}
      <Modal
        open={permModalOpen}
        onClose={() => setPermModalOpen(false)}
        aria-labelledby="perm-modal-title"
      >
        <Box sx={{ ...modalStyle, width: 450 }}>
          <div id="perm-modal-title" style={{ fontWeight: 'bold', marginBottom: 8, fontFamily: 'Poppins,sans-serif', fontSize: '16px' }}>
            Edit Permission - <span style={{ color: '#78c144' }}>{permFarmer?.name}</span>
          </div>
          {permStartDate && permEndDate && permEditEnabled && (
            <div style={{ fontSize: '13px', color: '#fff', background: '#78c144', padding: '8px 12px', borderRadius: 4, marginBottom: 12, fontFamily: 'Poppins,sans-serif', fontWeight: 'bold' }}>
              ✓ Field officers can edit between <b>{permStartDate}</b> and <b>{permEndDate}</b>
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, fontFamily: 'Poppins,sans-serif', fontSize: '14px', fontWeight: 'bold' }}>
              <input
                type="checkbox"
                checked={permEditEnabled}
                onChange={(e) => setPermEditEnabled(e.target.checked)}
                style={{ width: 18, height: 18, accentColor: '#78c144' }}
              />
              Allow Field Officers to <b style={{ color: '#78c144' }}>Edit</b> this Farmer
            </label>
            <div style={{ marginTop: 8 }}>
              <CustomDatePicker
                label="Permission Valid From"
                value={permStartDate ? dayjs(permStartDate) : null}
                onChange={(date) => setPermStartDate(date ? date.format('YYYY-MM-DD') : '')}
              />
            </div>
            <div style={{ marginTop: 8 }}>
              <CustomDatePicker
                label="Permission Valid Until"
                value={permEndDate ? dayjs(permEndDate) : null}
                onChange={(date) => setPermEndDate(date ? date.format('YYYY-MM-DD') : '')}
              />
            </div>
          </div>
          <div id="delete-modal-description" style={{ marginTop: 16 }}>
            <Button variant="contained" className="yes" onClick={handleSavePermission}>
              Save
            </Button>
            <Button variant="contained" className="no" onClick={() => setPermModalOpen(false)}>
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default Farmers;
